import { createAction } from '@reduxjs/toolkit';

import { GenericPayloadType } from '@ezugi/types';

import {
  AuthParams,
  FormatConfig,
  PreloaderConfig,
  configActionsFromSlice,
} from '../reducers/config';

export const configActions = {
  config: configActionsFromSlice,
  authParams: {
    set: createAction<AuthParams>('authParams/set'),
  },
  definitions: {
    set: createAction<GenericPayloadType>('definitions/set'),
  },
  preloader: {
    set: createAction<PreloaderConfig>('preloader/set'),
  },
  skin: {
    set: createAction<GenericPayloadType>('skin/set'),
  },
  retail: {
    set: createAction<GenericPayloadType>('retail/set'),
  },
  format: {
    set: createAction<FormatConfig>('format/set'),
  },
  errorCode: {
    set: createAction<GenericPayloadType>('errorCode/set'),
  },
};
